module.exports = __webpack_public_path__ + "media/images/m-company-ad2e88b8.png";